module.exports = __webpack_public_path__ + "static/media/ic_team.405ef870.png";